/******/ (() => { // webpackBootstrap
/******/ 	"use strict";

;// ./src/js/Axeptio.js
class Axeptio {
  constructor() {
    this.footerLinksSelector = '.footer .footer__links a';
  }

  init = () => {
    const footerLinks = document.querySelectorAll(this.footerLinksSelector);

    if (footerLinks.length === 0) {
      return;
    }

    footerLinks.forEach((link) => {
      if (link.href.includes('#replaceAxeptio')) {
        // eslint-disable-next-line no-script-url
        link.href = 'javascript:openAxeptioCookies()';
      }
    });
  };
}

;// ./src/js/DeliveryDelay.js
class DeliveryDelay {
  constructor() {
    this.textIconSelector = '.wq-delivery-infos__text-icon';
    this.firstDateSelector = '.wq-delivery-infos__text-bold-date--first';
    this.secondDateSelector = '.wq-delivery-infos__text-bold-date--second';
    this.holidays = [];
  }

  init = async () => {
    const textIcons = document.querySelectorAll(this.textIconSelector);

    if (!textIcons.length > 0) {
      return;
    }

    const today = new Date();
    const year = today.getFullYear();

    try {
      const response = await fetch(
        `https://calendrier.api.gouv.fr/jours-feries/metropole/${year}.json`
      );
      const data = await response.json();
      this.holidays = Object.keys(data).map((date) => new Date(date));
    } catch (error) {
      /* eslint-disable-next-line no-console */
      console.error('Erreur lors du chargement des jours fériés :', error);
    }

    textIcons.forEach((textIcon) => {
      const firstDate = textIcon.querySelector(this.firstDateSelector);
      const secondDate = textIcon.querySelector(this.secondDateSelector);
      const delayMin = firstDate.dataset.deliveryDelayMin;
      const delayMax = secondDate.dataset.deliveryDelayMax;

      if (!firstDate || !secondDate) {
        return;
      }

      const options = {
        month: 'short',
        day: 'numeric',
      };

      const estimatedDate = this.addWorkingDays(today, delayMin);
      firstDate.innerText = estimatedDate.toLocaleDateString('fr-FR', options);

      const estimatedDateMax = this.addWorkingDays(today, delayMax);
      secondDate.innerText = estimatedDateMax.toLocaleDateString(
        'fr-FR',
        options
      );

      textIcon.style.opacity = 1;
    });
  };

  isWorkingDay = (date) => {
    const day = date.getDay();
    const isWeekend = day === 0 || day === 6; // Sunday = 0, Saturday = 6
    const isHoliday = this.holidays.some(
      (holiday) => holiday.toDateString() === date.toDateString()
    );
    return !isWeekend && !isHoliday;
  };

  addWorkingDays = (startDate, daysToAdd) => {
    const date = new Date(startDate);
    let addedDays = 0;
    while (addedDays < daysToAdd) {
      date.setDate(date.getDate() + 1);
      if (this.isWorkingDay(date)) {
        addedDays++;
      }
    }
    return date;
  };
}

;// ./src/js/MenuUtilsNav.js
class MenuUtilsNav {
  constructor() {
    this.utilsNavSelector = '.js-utils-nav';
    this.headerSelector = '.js-header';
    this.dropdownItemSelector = '.header__utils-nav-item--dropdown';
    this.dropdownItemOpenClass = 'header__utils-nav-item--open';
    this.dropdownOpenClass = 'is-open';
    this.headerOpenClass = 'is-megamenu-open';
    this.abortController = null;
  }

  init = () => {
    const utilsNav = document.querySelector(this.utilsNavSelector);

    if (!utilsNav) {
      return;
    }

    this.destroy();
    this.abortController = new AbortController();
    const { signal } = this.abortController;

    const header =
      utilsNav.closest(this.headerSelector) ||
      document.querySelector(this.headerSelector);

    if (!header) {
      return;
    }

    const dropdownItems = utilsNav.querySelectorAll(this.dropdownItemSelector);

    const closeMainNavDropdowns = () => {
      document
        .querySelectorAll('nav.js-nav .js-dropdown.is-visible')
        .forEach((dropdown) => {
          dropdown.classList.remove('is-visible');
        });

      document
        .querySelectorAll('nav.js-nav .header__nav-sublinks.is-visible')
        .forEach((sublink) => {
          sublink.classList.remove('is-visible');
        });
    };

    const closeAll = () => {
      dropdownItems.forEach((item) => {
        item.classList.remove(this.dropdownItemOpenClass);

        const link = item.querySelector('.header__utils-nav-link');
        const dropdown = item.querySelector('.header__utils-nav-dropdown');

        if (link) {
          link.setAttribute('aria-expanded', 'false');
        }

        if (dropdown) {
          dropdown.classList.remove(this.dropdownOpenClass);
        }
      });

      if (!document.querySelector('nav.js-nav .js-dropdown.is-visible')) {
        header.classList.remove(this.headerOpenClass);
      }
    };

    const openItem = (item) => {
      closeMainNavDropdowns();
      closeAll();

      const dropdown = item.querySelector('.header__utils-nav-dropdown');
      const link = item.querySelector('.header__utils-nav-link');

      if (!dropdown) {
        return;
      }

      item.classList.add(this.dropdownItemOpenClass);
      dropdown.classList.add(this.dropdownOpenClass);

      if (link) {
        link.setAttribute('aria-expanded', 'true');
      }

      header.classList.add(this.headerOpenClass);
    };

    dropdownItems.forEach((item) => {
      item.addEventListener(
        'mouseenter',
        () => {
          openItem(item);
        },
        { signal }
      );

      item.addEventListener(
        'mouseleave',
        (event) => {
          const related = event.relatedTarget;

          if (related && item.contains(related)) {
            return;
          }

          closeAll();
        },
        { signal }
      );
    });

    utilsNav
      .querySelectorAll(
        `.header__utils-nav-item:not(${this.dropdownItemSelector})`
      )
      .forEach((item) => {
        item.addEventListener('mouseenter', closeAll, { signal });
      });

    utilsNav.addEventListener('mouseleave', closeAll, { signal });

    document.addEventListener('shopify:section:load', this.handleSectionLoad, {
      signal,
    });
  };

  handleSectionLoad = (event) => {
    if (event.target.querySelector?.(this.utilsNavSelector)) {
      this.init();
    }
  };

  destroy = () => {
    this.abortController?.abort();
    this.abortController = null;
  };
}

;// ./src/js/NewsletterPopupClose.js
class NewsletterPopupClose {
  constructor() {
    this.closeButtonSelector = '.newsletter-popup__button-close';
  }
  init = () => {
    const closeButton = document.querySelector(this.closeButtonSelector);
    closeButton.addEventListener('click', () => {
      const popup = closeButton.closest('newsletter-popup');
      popup?.hide();
    });
  };
}

;// ./src/js/SubscriberPrice.js
class SubscriberPrice {
  constructor() {
    this.productSelector = '.main-product__section';
    this.subscriberPriceSelector = '.price__subscriber-price';
    this.subscriberPriceValueSelector = '.price__subscriber-price-value';
    this.discountPercentage = 0.1;
  }

  init = () => {
    const product = document.querySelector(this.productSelector);

    if (!product) {
      return;
    }

    const subscriberPrice = product.querySelector(this.subscriberPriceSelector);
    const subscriberPriceValue = product.querySelector(
      this.subscriberPriceValueSelector
    );

    if (!subscriberPrice || !subscriberPriceValue) {
      return;
    }

    document.addEventListener('variant:change', (e) => {
      const discountedPrice =
        e.detail.variant.price -
        e.detail.variant.price * this.discountPercentage;
      const formattedPrice = (discountedPrice * 0.01)
        .toFixed(2)
        .replace('.', ',');

      subscriberPriceValue.innerText = `${formattedPrice}€`;
    });
  };
}

;// ./src/main.js

// JS goes here






window.addEventListener('load', () => {
  const classes = [
    new Axeptio(),
    new DeliveryDelay(),
    new MenuUtilsNav(),
    new NewsletterPopupClose(),
    new SubscriberPrice(),
  ];
  classes.forEach((classe) => classe.init());
});

/******/ })()
;